module.exports = __webpack_public_path__ + "media/images/LOGO_W-f8b7de0ced3feeaef5b6b458ea858355.png";